export const baseUrl = "https://ihmcare.net/api/";
